import React from "react";
import Carousel from "../components/Carousel";
import { Medals } from "../components/Medals";
const Resources = () => (
  <React.Fragment>
    <Carousel />
    <Medals />
  </React.Fragment>
);

export default Resources;
